import React from 'react';
export const LoaderText: React.FunctionComponent<{ size?: 'small' | 'medium' | 'large' }> = ({ size = 'medium' }) => (
  <span className={`loader-text ${size}`}></span>
);
